import { connect } from 'react-redux'
import SlidesRemoveConfirmModal from './SlidesRemoveConfirmModal'
import slidesActions from '../../dataStore/actions/slides'

const mapDispatchToProps = dispatch => ({
  onCancel: () => dispatch(slidesActions.cancelRemoveSlides()),
  onConfirm: () => dispatch(slidesActions.confirmSlidesRemoval())
})

export default connect(null, mapDispatchToProps)(SlidesRemoveConfirmModal)
